<div class="personal-details-container" [formGroup]="formGroup">

  <div class="section-card">

    <div class="container-fluid">

      <div class="row g-3">

        <!-- Full Name -->
        <div class="col-md-6">
          <mat-label class="field-label">Name as in NRIC / Passport</mat-label>
          <mat-form-field class="w-100 custom-form-field">
            <input matInput formControlName="fullName" placeholder="Enter Name as in NRIC" required>
            @if(this.formGroup.controls["fullName"].invalid
            && (this.formGroup.controls["fullName"].touched ||
            this.formGroup.controls["fullName"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["fullName"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Preferred Name -->
        <div class="col-md-6">
          <mat-label class="field-label">Preferred Name (Optional)</mat-label>
          <mat-form-field class="w-100 custom-form-field">
            <input matInput formControlName="preferredName" placeholder="Enter Preferred Name ">
          </mat-form-field>
        </div>

        <!-- NRIC -->
        <div class="col-md-6">
          <mat-label class="field-label">NRIC No.</mat-label>
          <mat-form-field class="w-100 custom-form-field">
            <input matInput formControlName="nric" placeholder="Enter NRIC No." [required]="this.nricrequired()">
            @if(this.formGroup.controls["nric"].invalid
            && (this.formGroup.controls["nric"].touched ||
            this.formGroup.controls["nric"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["nric"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-label class="field-label">Attachment (NRIC)</mat-label>

          <div class="upload-box">
            <input type="file" id="nricattachmentfileName" accept=".pdf,.jpg,.jpeg,.png"
              [disabled]="readonly() || this.passportRequired()"
              (change)="onAttachmentFileChange($event,'nricattachmentfileName','attachment_nric')" />
            <input type="text" formControlName="nricattachmentfileName" [required]="nricrequired()" hidden>

            <!-- Show filename OR placeholder -->
            @if(!this.formGroup.get('nricattachmentfileName')?.value){
            <span>
              Choose a file
            </span>
            }
            @if(this.formGroup.get('nricattachmentfileName')?.value){
            <div class="attachment-row">
              <span class="file-name">
                {{ this.formGroup.get('nricattachmentfileName')?.value }}
              </span>
              @if(readonly() == false){
              <button mat-icon-button color="primary" class="delete-btn"
                (click)="removeFile('nricattachmentfileName', 'attachment_nric', 'Attachment(NRIC)')">
                <mat-icon>close</mat-icon>
              </button>
              }
              <button mat-icon-button color="primary" class="delete-btn"
                (click)="previewAttachment('nricattachmentfileName','Attachment(NRIC)')">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
            }
          </div>

          <!-- Validation -->
          @if(this.formGroup.controls["nricattachmentfileName"].invalid
          && (this.formGroup.controls["nricattachmentfileName"].touched ||
          this.formGroup.controls["nricattachmentfileName"].dirty)
          ) {
          <mat-error>
            @if(this.formGroup.controls["nricattachmentfileName"].errors?.["required"]) {
            <span>{{message}}</span>
            }@else if(this.formGroup.controls["nricattachmentfileName"].errors?.['invalidType']){
            <span>Only PDF, JPG, PNG files are allowed.</span>
            }
            @else if(this.formGroup.controls["nricattachmentfileName"].errors?.['maxSize']){
            <span>File size must be less than or equal to 5MB.</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </div>

        <!-- Gender -->
        <div class="col-md-6">
          <mat-label class="field-label">Gender</mat-label>
          <mat-radio-group formControlName="gender" class="d-flex gap-3 mt-2" required>
            <mat-radio-button value="male">Male</mat-radio-button>
            <mat-radio-button value="female">Female</mat-radio-button>
          </mat-radio-group>
          @if(this.formGroup.controls["gender"].invalid
          && (this.formGroup.controls["gender"].touched ||
          this.formGroup.controls["gender"].dirty)
          ) {
          <mat-error>
            @if(this.formGroup.controls["gender"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </div>

        <!-- DOB -->
        <div class="col-md-6">
          <mat-label class="field-label">Date Of Birth</mat-label>
          <mat-form-field class="w-100">
            <input matInput [matDatepicker]="picker" formControlName="dob" placeholder="DD/MM/YYYY" required>
            <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if(this.formGroup.controls["dob"].invalid
            && (this.formGroup.controls["dob"].touched ||
            this.formGroup.controls["dob"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["dob"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

      </div>

    </div>

  </div>

  <!-- Nationality Section -->
  <div class="section-card mt-4">

    <h3 class="section-header">
      <mat-icon>flag</mat-icon>
      Nationality
    </h3>

    <mat-radio-group formControlName="nationality" class="d-flex flex-wrap gap-3 mb-3" required>
      <mat-radio-button value="Singapore Citizen">Singapore Citizen</mat-radio-button>
      <mat-radio-button value="Singapore Permanent Resident">Singapore Permanent Resident</mat-radio-button>
      <mat-radio-button value="others">Others</mat-radio-button>
    </mat-radio-group>
    @if(this.formGroup.controls["nationality"].invalid
    && (this.formGroup.controls["nationality"].touched ||
    this.formGroup.controls["nationality"].dirty)
    ) {
    <mat-error>
      @if(this.formGroup.controls["nationality"].errors?.["required"]) {
      <span>{{message}}</span>
      }
      @else {
      <span></span>
      }
    </mat-error>
    }

    <p class="note">
      For Singapore Permanent Resident & Others, please state:
    </p>
    <div class="row g-3">

      <div class="col-md-6">
        <mat-label class="field-label">Nationality</mat-label>
        <mat-form-field class="w-100">
          <mat-select formControlName="otherNationality" placeholder="Select Nationality">
            @for(nationality of this.nationalities; track nationality) {
            <mat-option value="{{nationality.value}}">{{nationality.name}}</mat-option>
            }
          </mat-select>
          @if(this.formGroup.controls["otherNationality"].invalid
          && (this.formGroup.controls["otherNationality"].touched ||
          this.formGroup.controls["otherNationality"].dirty)
          ) {
          <mat-error>
            @if(this.formGroup.controls["otherNationality"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-label class="field-label">Country of Birth </mat-label>
        <mat-form-field class="w-100">
          <mat-select formControlName="countryofbirth" placeholder="Select Country of Birth" required>
            @for(country of this.countries; track country) {
            <mat-option value="{{country.value}}">{{country.name}}</mat-option>
            }
          </mat-select>
          @if(this.formGroup.controls["countryofbirth"].invalid
          && (this.formGroup.controls["countryofbirth"].touched ||
          this.formGroup.controls["countryofbirth"].dirty)
          ) {
          <mat-error>
            @if(this.formGroup.controls["countryofbirth"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-label class="field-label">FIN or Passport No</mat-label>
        <mat-form-field class="w-100">
          <input matInput formControlName="passport" placeholder="Enter FIN or Passport No "
            [required]="this.passportRequired()">
          @if(this.formGroup.controls["passport"].invalid
          && (this.formGroup.controls["passport"].touched ||
          this.formGroup.controls["passport"].dirty)
          ) {
          <mat-error>
            @if(this.formGroup.controls["passport"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-label class="field-label">Attachment (FIN or Passport)</mat-label>
        <div class="upload-box">
          <input type="file" id="finorpassportattachmentfileName" #fileInput accept=".pdf,.jpg,.jpeg,.png"
            [disabled]="readonly() || this.nricrequired()"
            (change)="onAttachmentFileChange($event,'finorpassportattachmentfileName','attachment_finorpassport')">
          <input type="text" formControlName="finorpassportattachmentfileName" [required]="this.passportRequired()"
            hidden>

          <!-- Show filename OR placeholder -->
          @if(!this.formGroup.get('finorpassportattachmentfileName')?.value){
          <span>
            Choose a file
          </span>
          }
          @if(this.formGroup.get('finorpassportattachmentfileName')?.value){
          <div class="attachment-row">
            <span class="file-name">
              {{ this.formGroup.get('finorpassportattachmentfileName')?.value }}
            </span>
             @if(readonly() == false){
            <button mat-icon-button color="primary" class="delete-btn"
              (click)="removeFile('finorpassportattachmentfileName','attachment_finorpassport','Attachment(FIN or Passport)')">
              <mat-icon>close</mat-icon>
            </button>
             }
            <button mat-icon-button color="primary" class="delete-btn"
                (click)="previewAttachment('finorpassportattachmentfileName','Attachment(FIN or Passport)')">
                <mat-icon>visibility</mat-icon>
            </button>
          </div>
          }
        </div>
        @if(this.formGroup.controls["finorpassportattachmentfileName"].invalid
        && (this.formGroup.controls["finorpassportattachmentfileName"].touched ||
        this.formGroup.controls["finorpassportattachmentfileName"].dirty)
        ) {
        <mat-error>
          @if(this.formGroup.controls["finorpassportattachmentfileName"].errors?.["required"]) {
          <span>{{message}}</span>
          }@else if(this.formGroup.controls["finorpassportattachmentfileName"].errors?.['invalidType']){
          <span>Only PDF, JPG, PNG files are allowed.</span>
          }
          @else if(this.formGroup.controls["finorpassportattachmentfileName"].errors?.['maxSize']){
          <span>File size must be less than or equal to 5MB.</span>
          }
          @else {
          <span></span>
          }
        </mat-error>
        }
      </div>


    </div>

  </div>


  <!-- Race Section -->
  <div class="section-card mt-4">

    <h3 class="section-header">
      <mat-icon>supervisor_account</mat-icon>
      Race
    </h3>

    <div class="row">
      <div class="col-md-12">

        <mat-radio-group formControlName="race" class="d-flex flex-wrap gap-3" required>
          <mat-radio-button value="chinese">Chinese</mat-radio-button>
          <mat-radio-button value="malay">Malay</mat-radio-button>
          <mat-radio-button value="indian">Indian</mat-radio-button>
          <mat-radio-button value="others">Others</mat-radio-button>
        </mat-radio-group>
        @if(this.formGroup.controls["race"].invalid
        && (this.formGroup.controls["race"].touched ||
        this.formGroup.controls["race"].dirty)
        ) {
        <mat-error>
          @if(this.formGroup.controls["race"].errors?.["required"]) {
          <span>{{message}}</span>
          }
          @else {
          <span></span>
          }
        </mat-error>
        }

      </div>

      @if(formGroup.get('race')?.value === 'others'){
      <div class="col-md-6 mt-3">
        <mat-label class="field-label">Specify Race</mat-label>
        <mat-form-field class="w-100">
          <input matInput formControlName="raceSpecify" placeholder="Please specify">
        </mat-form-field>
      </div>
      }
    </div>

  </div>

  <!-- Marital Status -->
  <div class="section-card mt-4">

    <h3 class="section-header">
      <mat-icon>favorite</mat-icon>
      Marital Status
    </h3>

    <mat-radio-group formControlName="maritalStatus" class="d-flex flex-wrap gap-3" required>
      <mat-radio-button value="single">Single</mat-radio-button>
      <mat-radio-button value="married">Married</mat-radio-button>
      <mat-radio-button value="widowed">Widowed</mat-radio-button>
      <mat-radio-button value="divorced">Divorced</mat-radio-button>
    </mat-radio-group>
    @if(this.formGroup.controls["maritalStatus"].invalid
    && (this.formGroup.controls["maritalStatus"].touched ||
    this.formGroup.controls["maritalStatus"].dirty)
    ) {
    <mat-error>
      @if(this.formGroup.controls["maritalStatus"].errors?.["required"]) {
      <span>{{message}}</span>
      }
      @else {
      <span></span>
      }
    </mat-error>
    }
  </div>
</div>
@if(readonly() === false){
@if(isVisible() === true){
<div class="editor-actions">
  <button mat-stroked-button type="button" (click)="cancelSection()">Cancel</button>
  <button type="button" class="save-btn" (click)="saveSection()">
    <mat-icon>save</mat-icon>Save</button>
</div>
}@else{
<!-- Form Actions -->
<div class="form-actions mt-4 text-end">
  <!-- [disabled]="formGroup.invalid" -->
  <button mat-raised-button class="save-btn" (click)="saveAndContinue()">

    <span>Save & Continue</span>
    <mat-icon>arrow_forward</mat-icon>

  </button>

</div>
}
}